export enum RJExpressionNodeType
{
  TOKEN,
  CONSTANT,
  BINARY,
  GROUP,
  UNARY,
  SEQUENCE,
  FUNCTION,
  VARIABLE,
  CUSTOM
}
